import { createFileRoute } from '@tanstack/react-router';
import { MessagesLayout } from '@/features/messaging/pages/messages-layout';

export const Route = createFileRoute('/_app/messages')({ component: MessagesLayout });
